import { render, staticRenderFns } from "./authorizedVideo.vue?vue&type=template&id=322af1ad&scoped=true"
import script from "./authorizedVideo.vue?vue&type=script&lang=js"
export * from "./authorizedVideo.vue?vue&type=script&lang=js"
import style0 from "./authorizedVideo.vue?vue&type=style&index=0&id=322af1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322af1ad",
  null
  
)

export default component.exports